"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.todoRoutes = void 0;
const todoActions_openapi_1 = require("./todoActions.openapi");
exports.todoRoutes = [
    {
        name: 'todo.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo.list'] }
    },
    {
        name: 'todo.create',
        path: ['/'],
        method: 'POST',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo.create'] }
    },
    {
        name: 'todo.get',
        path: '/:id',
        method: 'GET',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo.get'] }
    },
    {
        name: 'todo.update',
        path: '/:id',
        method: 'PUT',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo.update'] }
    },
    {
        name: 'todo.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo.delete'] }
    },
    {
        name: 'todo-item.update',
        path: '/item/update',
        method: 'PUT',
        plugins: { openapi: todoActions_openapi_1.todoOpenApiDocs['todo-item.update'] }
    }
];
